export default {
	module: 'docModification',
	actions: {
		list: true,
		create: true,
		dynamicPaths: [
			{
				paths: {
					'/docModification/edit/:id': true,
				},
				keys: {
					':id': 3
				}
			}
		]
	}
}

